import { Bell, Mail } from 'lucide-react';

import { SettingsGroup } from '@/core/components/settings/settings-group';
import { useDictionary } from '@/core/providers/dictionary-provider';

/** Alerts & reports — not available yet; shows what is coming, inert. */
export function ReputationSetupAlertsSection() {
  const d = useDictionary().reputation.setup.alerts;
  const rows = [
    { icon: Bell, label: d.instantAlert },
    { icon: Mail, label: d.weeklyReport },
  ];
  return (
    <>
      <p className="text-muted-foreground rounded-[var(--r-settings-group,12px)] border border-dashed p-3.5 text-[13px] md:hidden">
        {d.comingSoon}
      </p>
      <SettingsGroup className="opacity-55 max-md:hidden" aria-disabled>
        {rows.map(({ icon: Icon, label }, index) => (
          <div
            key={label}
            className={
              index > 0
                ? 'flex items-center gap-3.5 border-t px-4 py-3.5 sm:px-5'
                : 'flex items-center gap-3.5 px-4 py-3.5 sm:px-5'
            }
          >
            <Icon className="text-muted-foreground size-[17px]" aria-hidden />
            <span className="flex-1 text-sm font-semibold">{label}</span>
            <span className="h-6 w-10 rounded-full bg-muted" aria-hidden />
          </div>
        ))}
      </SettingsGroup>
    </>
  );
}
